import React, { useEffect } from "react";
import { useLocation, Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import routes from "../routes.js";
import { baseURL } from "../config/config.js";
import { LoginDetails } from "../reduxToolkit/slice/auth.js";
import { post } from "../utils/apiManager";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const navigate = useNavigate(); // changes page (the <Navigate> redirect component is separate)
  const { token } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    let tokenCheck = localStorage.getItem("token");
    if (tokenCheck && tokenCheck !== "null" && tokenCheck !== "undefined") {
      let data = { token: tokenCheck };
      const Url = `${baseURL}/admin/check-token`;
      post(Url, data).then((data) => {
        dispatch(LoginDetails({
          token: data?.token,
          name: data?.data?.name,
          userId: data?.data?._id,
          email: data?.data?.email,
          isLogin: true,
          profileImage: data?.data?.profileImage
        }));
        navigate("/admin/index");
      }).catch((err) => {
        console.log(err);
      });
    }
  }, [token]);

  React.useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.background = "#f5f7fb";
    return () => {
      document.body.style.background = "";
    };
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return <Route path={prop.path} element={prop.component} key={key} exact />;
      }
      return null;
    });
  };

  return (
    <div
      ref={mainContent}
      style={{
        minHeight: "100vh",
        background: "#f5f7fb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
      }}
    >
      {/* Logo / Brand */}
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 56,
          height: 56,
          borderRadius: 16,
          background: "#AD2429",
          marginBottom: 16,
          boxShadow: "0 4px 16px rgba(173,36,41,.25)",
        }}>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 22, letterSpacing: "-1px" }}>B</span>
        </div>
        <div style={{
          fontSize: 22,
          fontWeight: 700,
          color: "#0a1628",
          letterSpacing: "-0.5px",
          marginBottom: 4,
        }}>
          BidBuy<span style={{ color: "#AD2429" }}>Zoom</span>
        </div>
        <div style={{ fontSize: 13, color: "#8a9ab8", fontWeight: 500 }}>
          Super Admin Portal
        </div>
      </div>

      {/* Card */}
      <div style={{
        background: "#fff",
        borderRadius: 18,
        boxShadow: "0 4px 32px rgba(26,39,68,.08), 0 0 0 1px rgba(26,39,68,.05)",
        padding: "40px 40px 32px",
        width: "100%",
        maxWidth: 420,
      }}>
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </div>

      {/* Footer */}
      <div style={{ marginTop: 28, fontSize: 13, color: "#9aa5c0", textAlign: "center" }}>
        © {new Date().getFullYear()} Ablepro, Inc. d/b/a BidBuyZoom · All Rights Reserved
      </div>
    </div>
  );
};

export default Auth;
